import React, { useEffect, useState } from 'react';
import ExperienceSection from '../../components/About/ExperienceSection';
import SectionLayout from '../../components/SectionLayout/SectionLayout';
import SkillsSlider from '../../components/Skills/SkillsSlider';
import { db } from '../../firebase'; // Asegúrate de tener tu config de firebase exportando db
import { doc, getDoc, collection, query, where, getDocs } from "firebase/firestore";
import Loader from '../../components/Loader';

const AboutPage = ({ lang }) => {
  const [aboutData, setAboutData] = useState(null);
  const [skillsList, setSkillsList] = useState([]);
  const [experience, setExperiences] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);

      // AboutPage (documento por idioma)
      const aboutSnap = await getDoc(doc(db, "aboutPage", lang));
      setAboutData(aboutSnap.data());

      // Skills (colección por idioma)
      const q = query(collection(db, "skills"), where("lang", "==", lang));
      const skillsSnap = await getDocs(q);
      setSkillsList(skillsSnap.docs.map(doc => doc.data()));

      // Skills (colección por idioma)
      const expQ = query(collection(db, "experiences"), where("lang", "==", lang));
      const experiencesSnap = await getDocs(expQ);
      setExperiences(experiencesSnap.docs.map(doc => doc.data()));
      console.log(experiencesSnap.docs.map(doc => doc.data()));

      setLoading(false);
    }
    fetchData();
  }, [lang]);

  if (loading || !aboutData) {
    if (loading) return <Loader text={lang === 'en' ? 'Loading' : 'Cargando'}/>;
  }

  const { hero, experienceTitle, interestingFacts, skillsTitle } = aboutData;

  return (
    <div className="about-page">
      {/* Sección Sobre Mí */}
      <section className="about-page__hero">
        <div className="about-page__hero-content">
          <h1 className="about-page__hero-title">{hero.title}</h1>
          <p className="about-page__hero-description" dangerouslySetInnerHTML={{ __html: hero.description }}/>
        </div>
        <div className="about-page__hero__mouse-scroll-cont">
          <div className="mouse"></div>
      </div>
      </section>

      {/* Sección Skills */}
      <SectionLayout id="skills" title={skillsTitle}>
        <SkillsSlider skills={skillsList} />
      </SectionLayout>

      {/* Sección Experiencia */}
      <SectionLayout id="experience" title={experienceTitle}>
        <ExperienceSection experiences={experience} />
      </SectionLayout>

      {/* Sección Interesting Facts */}
      {Array.isArray(interestingFacts) && interestingFacts.length > 0 && (
        <>
          {interestingFacts.map((fact, idx) => (
            <SectionLayout
              key={idx}
              id={`interesting-fact-${idx}`}
              title={fact.title}
            >
              <p
                className="about-page__interesting-facts-description"
                dangerouslySetInnerHTML={{ __html: fact.description }}
              />
            </SectionLayout>
          ))}
        </>
      )}
    </div>
  );
};

export default AboutPage;